export class Placement {
    public __classname__: string = 'Placement';

	public Id : string | null = null;
	public Left : number | null = null;
	public Top : number | null = null;
	public Width : number | null = null;
	public Height : number | null = null;

    constructor(
        Id: string | null = null,
        Left: number | null = null,
        Top: number | null = null,
        Width: number | null = null,
        Height: number | null = null
    ) {
        this.Id = Id;
        this.Left = Left;
        this.Top = Top;
        this.Width = Width;
        this.Height = Height;
    }
}